export type Locale =
  | 'cs'
  | 'da'
  | 'de'
  | 'en'
  | 'en_GB'
  | 'en_ZZ'
  | 'es'
  | 'fi'
  | 'fr'
  | 'hr'
  | 'hu'
  | 'it'
  | 'ja'
  | 'ko'
  | 'nb'
  | 'nl'
  | 'pl'
  | 'pt_BR'
  | 'ru'
  | 'sl'
  | 'sr_RS'
  | 'sr_YR'
  | 'sv'
  | 'th'
  | 'tr'
  | 'uk'
  | 'vi'
  | 'zh'
  | 'zh_TW';

export const importI18n = async (locale: Locale) => {
	switch (locale) {
		case 'cs':
			return import(/* webpackChunkName: "search-ai-translations-i18n-cs" */'./cs');
		case 'da':
			return import(/* webpackChunkName: "search-ai-translations-i18n-da" */'./da');
		case 'de':
			return import(/* webpackChunkName: "search-ai-translations-i18n-de" */'./de');
		case 'en':
			return import(/* webpackChunkName: "search-ai-translations-i18n-en" */'./en');
		case 'en_GB':
			return import(/* webpackChunkName: "search-ai-translations-i18n-en_GB" */'./en_GB');
		case 'en_ZZ':
			return import(/* webpackChunkName: "search-ai-translations-i18n-en-ZZ" */'./en_ZZ');
		case 'es':
			return import(/* webpackChunkName: "search-ai-translations-i18n-es" */'./es');
		case 'fi':
			return import(/* webpackChunkName: "search-ai-translations-i18n-fi" */'./fi');
		case 'fr':
			return import(/* webpackChunkName: "search-ai-translations-i18n-fr" */'./fr');
		case 'hr':
			return import(/* webpackChunkName: "search-ai-translations-i18n-hr" */'./hr');
		case 'hu':
			return import(/* webpackChunkName: "search-ai-translations-i18n-hu" */'./hu');
		case 'it':
			return import(/* webpackChunkName: "search-ai-translations-i18n-it" */'./it');
		case 'ja':
			return import(/* webpackChunkName: "search-ai-translations-i18n-ja" */'./ja');
		case 'ko':
			return import(/* webpackChunkName: "search-ai-translations-i18n-ko" */'./ko');
		case 'nb':
			return import(/* webpackChunkName: "search-ai-translations-i18n-nb" */'./nb');
		case 'nl':
			return import(/* webpackChunkName: "search-ai-translations-i18n-nl" */'./nl');
		case 'pl':
			return import(/* webpackChunkName: "search-ai-translations-i18n-pl" */'./pl');
		case 'pt_BR':
			return import(/* webpackChunkName: "search-ai-translations-i18n-pt_BR" */'./pt_BR');
		case 'ru':
			return import(/* webpackChunkName: "search-ai-translations-i18n-ru" */'./ru');
		case 'sl':
			return import(/* webpackChunkName: "search-ai-translations-i18n-sl" */'./sl');
		case 'sr_RS':
			return import(/* webpackChunkName: "search-ai-translations-i18n-sr_RS" */'./sr_RS');
		case 'sr_YR':
			return import(/* webpackChunkName: "search-ai-translations-i18n-sr_YR" */'./sr_YR');
		case 'sv':
			return import(/* webpackChunkName: "search-ai-translations-i18n-sv" */'./sv');
		case 'th':
			return import(/* webpackChunkName: "search-ai-translations-i18n-th" */'./th');
		case 'tr':
			return import(/* webpackChunkName: "search-ai-translations-i18n-tr" */'./tr');
		case 'uk':
			return import(/* webpackChunkName: "search-ai-translations-i18n-uk" */'./uk');
		case 'vi':
			return import(/* webpackChunkName: "search-ai-translations-i18n-vi" */'./vi');
		case 'zh':
			return import(/* webpackChunkName: "search-ai-translations-i18n-zh" */'./zh');
		case 'zh_TW':
			return import(/* webpackChunkName: "search-ai-translations-i18n-zh_TW" */'./zh_TW');
	}
};
